module.exports = __webpack_public_path__ + "static/media/YM70_4.7dcaef80.jpg";